import { Button } from 'antd';
import { InputIconSelect, InputText } from '../Input';
import { slugify } from '../../utils/strings';
import { CLOSE, DRAG_HANDLE } from '../icons';

/**
 * One row of a choice element's list in the card editor: its label (the
 * stored value follows it), its icon and color, and its own hint (KPR-1976).
 * Moved out of CardDefinitionForm.js, which re-exports it.
 */
export default function CardDefElementChoice(props) {

	const {
		index,
		choiceIndex,
		choice,
		onChange,
		onRemove,
		dragHandleProps,
		basePath = null,
	} = props;

	const base = `${basePath || `elements[${index}]`}.options.choices[${choiceIndex}]`;

	// The stored choice value is derived from the label (there is no separate
	// value input in this form). Follow label edits until the value has
	// diverged (e.g. set by the API or the legacy collection form).
	const handleLabelChange = (name, newLabel) => {
		const prevLabel = choice?.label || '';
		onChange(name, newLabel);
		if (!choice?.value || choice.value === slugify(prevLabel)) {
			onChange(`${base}.value`, slugify(newLabel));
		}
	};

	const handle = dragHandleProps ? (
		<span
			ref={dragHandleProps.setActivatorNodeRef}
			{...dragHandleProps.attributes}
			{...dragHandleProps.listeners}
			style={{ cursor: 'grab', display: 'inline-flex', alignItems: 'center', marginRight: 8 }}
		>
			<DRAG_HANDLE />
		</span>
	) : null;

	return (
		<div className='choice-row'>
			<div className='choice-row__fields'>
				{handle}
				<InputText
					elementName={`${base}.label`}
					elementLabel='Label'
					value={choice.label}
					onChange={handleLabelChange}
					required={true}
				/>
				<InputIconSelect
					elementName={`${base}.icon`}
					elementLabel='Icon and color'
					value={choice.icon}
					onChange={onChange}
					colorElementName={`${base}.color`}
					colorValue={choice.color}
					onColorChange={onChange}
				/>

				<Button
					type='text'
					danger
					icon={<CLOSE />}
					aria-label='Remove choice'
					title='Remove choice'
					onClick={() => onRemove(choiceIndex)}
				>
					Remove
				</Button>
			</div>
			{/* The choice's own hint (KPR-1976): what picking it means, shown
			    with the choice on the item form, so the label can stay short.
			    The element's Help text is separate and unchanged. */}
			<div className='choice-row__hint'>
				<InputText
					elementName={`${base}.help`}
					elementLabel='Hint'
					value={choice.help || ''}
					onChange={onChange}
					placeholder='Optional. What picking this choice means'
				/>
			</div>
		</div>
	);

};
